import React, { Fragment, useState, useEffect, useContext } from 'react';
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  CustomInput,
  FormGroup,
  Label,
  Spinner
} from 'reactstrap';
import { useForm } from 'react-hook-form';
import CurrencyInput from 'react-currency-input-field';
import CountUp from 'react-countup';
import DetailRow from '../../../components/GestionPersonaEmpresa/personDetails/DetailRow';
import WizardInput from '../../../components/auth/wizard/WizardInput';
import cogoToast from 'cogo-toast';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RecaudoContext } from '../RecaudoContext';
import { EnvironmentContext } from '../../../context/Context';
import ButtonIcon from '../../../components/common/ButtonIcon';
import IconButton from '@material-ui/core/IconButton';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import MainTable from '../../../components/tables/MainTable';
import paymentsType from '../../../data/recaudo/paymentsType';
import { desembolsoServices, generalServices, recaudoServices } from '../../../services';
import { getTodayStr } from '../../../helpers/dateFormatters';
import numToWord from '../../../helpers/numToWord';
import RecaudoInvoice from '../../recaudar/invoice/RecaudoInvoice';
import { refFormat } from '../../../helpers/tableFormatters';
import { currencyFormat as amountFormat, formatterId } from '../../../helpers/formatters'


function RecaudoClientModal({ open, toggle, data }) {
  const environment = useContext(EnvironmentContext);
  const context = useContext(RecaudoContext);
  const { client } = context;
  const { register, setValue, getValues, errors, watch } = useForm();

  const [requesting, setRequesting] = useState();
  const [invoiceProps, setInvoiceProps] = useState();
  const [success, setSuccess] = useState();

  useEffect(() => {
    if (!data) return;
    setSuccess(null);
    setInvoiceProps(null);
  }, [data])

  const onChange = async e => {
    let { name, value } = e.target;
    setValue(name, value);
  }

  const onRecaudo = async () => {
    setRequesting(true);
    const generalData = getValues();
    if (!data) {
      cogoToast.warn("Por favor complete los campos requeridos",
        { position: 'bottom-left', heading: 'Campos requeridos' });
      setRequesting(false);
      return;
    }

    // Anulación como en el estado de cuenta: el recaudo queda con estado 2 y el backend registra el
    // egreso de tesorería. La nota crédito anterior dejaba el período como pagado.
    const response = await recaudoServices.anularRecaudo(data.recaudo);
    if (!response || response.error) {
      cogoToast.error(response?.msg || "No se logro completar la solicitud de anulación de recaudo",
        { position: 'bottom-left', heading: 'Error' });
      setRequesting(false);
      return;
    }

    setSuccess(true);
    setRequesting(false);
  }

  const onOk = () => {
    setSuccess(false);
    toggle(true);
  }

  return (
    <Modal size="lg" isOpen={open}>
      <ModalHeader
        close={
          <div className='d-flex justify-content-center'>
            <FontAwesomeIcon
              onClick={onOk}
              style={{ cursor: 'pointer' }}
              size='lg'
              icon="times"
            />
          </div>}
      >
        <h5>{`Anular Recaudo Nro ${data ? data.recaudo : ''} - Crédito ${data ? data.credito : ''}`}</h5>
        <span className='text-primary' style={{ fontSize: '0.8em' }}>{data ? data.nombreConcepto : ''}</span>
      </ModalHeader>
      <ModalBody>
        {data && (
          <>
          {success ? (
            <div className="text-center mt-4">
              <FontAwesomeIcon icon="check" transform="shrink-2" className="text-success mr-1 fs-8" />
              <h6 className="fs-2 m-3">
                Anulación Exitosa!
              </h6>
              <p className="fs--1 mb-0">Si el recaudo había ingresado a caja, se registró el egreso en tesorería.</p>
            </div>
          ) : (
            <>
              <Row className="mx-0">
                <Col lg className="col-xxl-5">
                  <DetailRow title="Crédito">{data.credito || <span className='p-2'></span>}</DetailRow>
                  <DetailRow textNormal title="Fecha Recaudo" childrenClasses="uppercase">
                    {data.fecha || <span className='p-2'></span>}
                  </DetailRow>
                  <DetailRow childrenClasses="text-uppercase" title="Modalidad">{data.nombreModalidad || <span className='p-2'></span>}</DetailRow>
                </Col>
                <Col lg className="col-xxl-5">
                  <DetailRow childrenClasses="text-uppercase" title="Cliente">{data.nombreCliente || <span className='p-2'></span>}</DetailRow>
                  <DetailRow title="Valor Recaudado">
                    <CountUp end={data.valorRecaudo} duration={1} prefix="$" separator="." decimal="," decimals={2} />
                  </DetailRow>
                  <DetailRow childrenClasses="text-uppercase" title="Tipo Recaudo">{data.nombreTipoRecaudo || <span className='p-2'></span>}</DetailRow>
                </Col>
              </Row>

              <Row className="mx-0 mt-3 pt-3 border-top">
                <Col lg className="col-xxl-5">
                  <DetailRow title="Registrado">{data.fechaCreacion || <span className='p-2'></span>}</DetailRow>
                </Col>
                <Col lg className="col-xxl-5">
                  <DetailRow childrenClasses="text-uppercase" title="Usuario">{data.correo || <span className='p-2'></span>}</DetailRow>
                </Col>
              </Row>
            </>
          )}
            
          </>
        )}
      </ModalBody>
      <ModalFooter className="no-border">
        <Col className="text-right" >
          {success ? (
            <Button onClick={onOk} transform="shrink-3 down-2" color="primary" >
              Aceptar
            </Button>
          ) : (
            <>
              <Button onClick={() => toggle()} className="mr-2" transform="shrink-3 down-2" color="falcon-default" >
                Cancelar
              </Button>
              <Button onClick={onRecaudo} transform="shrink-3 down-2" color="primary" disabled={requesting}>
                Anular
              </Button>
            </>
          )}
          
        </Col>
      </ModalFooter>
    </Modal >
  )
}

export default RecaudoClientModal

